<template>
  <div>
    <vxe-grid
      ref="inventoryTable"
      border
      auto-resize
      highlight-hover-row
      :toolbar-config="tableToolbar"
      :data="tableData"
      :columns="tableColumns"
      :loading="loading"
      :height="tableHeight"
      size="small"
      :seq-config="{ startIndex: (tablePage.curPage - 1) * tablePage.pageSize }"
    >
      <template v-slot:toolbar_form>
        <slot name="header"></slot>
      </template>
      <template v-slot:pager>
        <slot name="pager"></slot>
      </template>
      <template v-slot:opt="{ row }">
        <div style="text-align: center">
          <el-dropdown trigger="click" @command="optCommand">
            <span class="el-dropdown-link">
              {{ $l('INDEX.choose_fabric_function') || '功能' }}
              <i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item
                v-for="(opt, index) in tableOpts"
                :key="index"
                :icon="opt.icon"
                :command="{ opt, data: row }"
                :divided="opt.divided"
                :disabled="opt.disabled ? opt.disabled(row) : false"
              >
                {{ opt.text }}
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </template>

      <template v-slot:status="{ row }">
        <el-tag
          size="mini"
          :type="
            row.status === 'Y'
              ? 'success'
              : row.status === 'D'
              ? 'danger'
              : row.status === 'N'
              ? 'warning'
              : ''
          "
        >
          {{ row.v_status }}
        </el-tag>
      </template>

      <template v-slot:createInfo="{ row }">
        <span>{{ row.createByName }}</span>
        <br />
        <span>{{ row.createTime }}</span>
      </template>
      <template v-slot:modifyInfo="{ row }">
        <span>{{ row.modifyByName }}</span>
        <br />
        <span>{{ row.modifyTime }}</span>
      </template>
      <template v-slot:empty="{}">
        <div style="text-align: center">
          <img src="/image/static/img/nodata.png" />
          <p class="no-data">
            {{ $l('INDEX.tips_no_data') || '暂无数据！' }}
          </p>
        </div>
      </template>
    </vxe-grid>
  </div>
</template>
<script>
import TableAutoHeight from '@/mixins/table-auto-height'
import tableColumns from './table-columns'
import tableOpts from './table-opts'
import EditLoading from '@/mixins/edit-loading'
export default {
  mixins: [TableAutoHeight, EditLoading],
  props: {
    tableData: { type: Array, default: () => [] },
    tablePage: { type: Object, default: () => {} },
    loading: { type: Boolean, default: false },
  },
  data() {
    return {
      tableToolbar: {
        slots: { buttons: 'toolbar_form' },
        refresh: { query: () => this.$emit('reload') },
        zoom: true,
        custom: true,
      },
      tableColumns: tableColumns(this),
    }
  },
  computed: {
    tableOpts() {
      const opts = tableOpts(this)
      return opts.filter(({ allow }) => (!allow ? true : this.allow(allow)))
    },
  },
  methods: {
    optCommand({ opt, data }) {
      const { menuType } = opt
      if (!menuType) return

      switch (menuType) {
        case 'detail':
        case 'edit':
          this.$emit('openEditDialog', { type: menuType, data })
          break
        case 'enabled':
          this.enabled(data)
          break
        case 'disabled':
          this.disabled(data)
          break
        case 'delete':
          this.del(data)
          break
        default:
          console.error('menuType configuration error: ', menuType)
      }
    },
    async enabled({ platformAccountCode }) {
      const confirm = await this.$confirm(
        '是否要启用该记录？',
        this.$l('INDEX.label_completeDesc'),
        {
          confirmButtonText: this.$l('INDEX.product_dialog_btn_confirm'),
          cancelButtonText: this.$l('INDEX.btn_cancel'),
          type: 'warning',
        }
      )
        .then(() => true)
        .catch(() => false)
      if (!confirm) return

      this.loadingOpen()
      const res = await this.$api
        .ecomOrderPlatformAccountDnabledApi({ platformAccountCode })
        .catch(() => null)
      this.loadingClose()
      if (!res) return
      const { status } = res
      if (status !== 200) {
        this.$message.error(this.$l('INDEX.tips_enable_no') || '启用失败！')
        return
      }
      this.$message({
        showClose: true,
        message: this.$l('INDEX.tips_enable_ok') || '启用成功！',
        type: 'success',
      })
      this.$emit('reload')
    },
    async disabled({ platformAccountCode }) {
      const confirm = await this.$confirm(
        '是否要禁用该账户？',
        this.$l('INDEX.label_completeDesc'),
        {
          confirmButtonText: this.$l('INDEX.product_dialog_btn_confirm'),
          cancelButtonText: this.$l('INDEX.btn_cancel'),
          type: 'warning',
        }
      )
        .then(() => true)
        .catch(() => false)
      if (!confirm) return

      this.loadingOpen()
      const res = await this.$api
        .ecomOrderPlatformAccountDisabledApi({ platformAccountCode })
        .catch(() => null)
      this.loadingClose()
      if (!res) return
      const { status } = res
      if (status !== 200) {
        this.$message.error(this.$l('INDEX.tips_disabled_no') || '禁用失败！')
        return
      }
      this.$message({
        showClose: true,
        message: this.$l('INDEX.tips_disabled_ok') || '禁用成功！',
        type: 'success',
      })
      this.$emit('reload')
    },
    async del({ platformAccountCode }) {
      const confirm = await this.$confirm(
        '是否要删除该账户？',
        this.$l('INDEX.label_completeDesc'),
        {
          confirmButtonText: this.$l('INDEX.product_dialog_btn_confirm'),
          cancelButtonText: this.$l('INDEX.btn_cancel'),
          type: 'warning',
        }
      )
        .then(() => true)
        .catch(() => false)
      if (!confirm) return

      this.loadingOpen()
      const res = await this.$api
        .ecomOrderPlatformAccountDelApi({ platformAccountCode })
        .catch(() => null)
      this.loadingClose()
      if (!res) return
      const { status } = res
      if (status !== 200) {
        this.$message.error(this.$l('INDEX.tips_delete_no') || '删除失败！')
        return
      }
      this.$message({
        showClose: true,
        message: this.$l('INDEX.tips_delete_ok') || '删除成功！',
        type: 'success',
      })
      this.$emit('reload')
    },
  },
}
</script>
